// Auto-refactored from translations.js on 2026-08-19
// Locale: uk

const uk = {
  wieMoeglich: { question: 'Як це можливо?', answer: 'Ми переосмислили ланцюг створення вартості.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Шлях STIG ROCK',
    fazit: 'Скорочений ланцюг постачання усуває найбільші статті витрат.',
    fazitBigPre: 'Це дає змогу отримати знижку до',
    fazitBigValue: '80%',
    steps: [ 'Шахта', 'Гранувальня', 'Сертифікація', 'Кінцевий клієнт' ]
  },
  nav: { language: 'Мова', contact: 'Контакт' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Унікальна можливість',
    subtitle: 'Формування капіталу з орієнтацією на майбутнє.',
    description: 'STIG ROCK — це міжнародна платформа, яка надає людям доступ до природних діамантів, сталого нарощування капіталу та унікальної спільноти.',
    scroll: 'Прокрутіть, щоб відкрити'
  },
  disclaimer: {
    overline: 'Юридична примітка',
    title: 'Disclaimer',
    paragraphs: [
      'Ця презентація служить виключно для інформаційних цілей і не є фінансовою, інвестиційною або податковою консультацією.',
      'STIG ROCK не є фінансовим продуктом, а стосується натуральних Diamond як реальних активів.',
      'Жодних гарантій щодо динаміки вартості, прибутку або доходів не надається. Показники минулого не є індикатором майбутніх результатів.',
      "Усі представлені розрахунки, пов'язані з комісійними, є лише прикладами і також не є гарантією."
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ПОБУДОВАНО', 'НА СТРУКТУРІ' ],
    body: 'STIG Group — це міжнародний концерн, побудований на чіткості, відповідальності та довгостроковій цінності. Кожен бренд, кожен проект і кожне партнерство відповідають єдиному стандарту — без компромісів і винятків.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ПОБУДОВАНО', 'НА СТРУКТУРІ' ],
        body: 'STIG Group — це міжнародний концерн, побудований на чіткості, відповідальності та довгостроковій цінності. Кожен бренд, кожен проект і кожне партнерство відповідають єдиному стандарту — без компромісів і винятків.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'СВІТ', 'ЕКСКЛЮЗИВНИХ DIAMOND' ],
        body: 'STIG ROCK — це сучасна концепція STIG Group, що поєднує високоякісні сертифіковані GIA Diamond з прозорими структурами та ексклюзивним клієнтським досвідом. Чіткі плани рішень, професійне виконання та міжнародна орієнтація.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'МІЖНАРОДНА', 'ТОРГІВЛЯ DIAMOND' ],
        body: 'Stig International є частиною STIG Group і спеціалізується на міжнародній торгівлі сертифікованими GIA Diamond. Фокус на якості, довірі та сучасних торгових структурах із глобальним партнерством.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ВІДПОВІДАЛЬНІСТЬ', 'ВІД САМОЇ ШАХТИ' ],
        body: 'Ethical Mines виступає за відповідальний видобуток, відстежуване походження та конфліктно-вільні Diamond. Від шахти до ринку — повна документація для забезпечення прозорості, цілісності та довгострокової відповідальності в усьому ланцюжку постачання.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Діаманти',
    stigDrawback: 'Реальний засіб збереження вартості',
    overline: 'Можливості',
    title: 'Можливості для накопичення капіталу',
    subtitle: 'Порівняння традиційних шляхів.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex або крипто',
        drawback: 'високоспекулятивно, непередбачувано, складно'
      },
      {
        tag: 'Aktien',
        name: 'Біржова торгівля',
        drawback: 'ризик коливань, необхідні знання, витрати часу'
      },
      {
        tag: 'Krypto',
        name: 'Торгівля',
        drawback: 'волатильність, регуляторні ризики, вразливості безпеки'
      }
    ]
  },
  chance: {
    overline: 'Diamanten',
    title: 'Недооцінена можливість',
    body: 'Diamond роками залишаються однією з найбільш стабільних за вартістю та перспективних форм інвестування, проте досі лише небагато хто використовував цей потенціал.',
    callout: 'Завдяки STIG ROCK ми вперше відкриваємо доступ до цих надзвичайних можливостей для кожного.'
  },
  wertentwicklung: {
    overline: 'Динаміка вартості 1995 — 2025',
    title: 'Історія про цінність.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Розвиток з 1995 по 2025'
  },
  hauptgruende: {
    overline: 'Головні причини',
    title: 'Шість причин обрати Diamond',
    lead: 'Diamond — це реальні активи, які існують незалежно від валют і фінансових систем — і зберігають свою цінність протягом століть.',
    items: [
      {
        n: '01',
        title: 'Кризостійка стабільність вартості',
        body: 'Гарантія реального активу. Незалежність від валют та фінансових систем.'
      },
      {
        n: '02',
        title: 'Абсолютна мобільність',
        body: 'Маленькі, легкі для зберігання та транспортування.'
      },
      {
        n: '03',
        title: 'Диверсифікація та дефіцит',
        body: 'Обмеженість пропозиції та природна лімітованість.'
      },
      { n: '04', title: 'Довгострокове зростання', body: '+185% з 1995 року.' },
      {
        n: '05',
        title: 'Прозорість та ексклюзивність',
        body: '4 C як гарантія: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Резерв королівських династій',
        body: 'Навіть королівські родини використовують Diamond як резерв капіталу.'
      }
    ]
  },
  markt: {
    overline: 'Обсяг ринку',
    title: '99 — 108 Mrd. USD',
    sub: 'Обсяг торгівлі у 2025 році',
    forecast: 'Прогноз до ~2032 / 2034: прибл. 140 – 168 Mrd. USD при помірному зростанні (~4 – 5 % p.a.).',
    source: 'Джерело: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Інновація',
    title: 'Інновація. Вперше у світі.',
    body: 'STIG ROCK — це перша у світі платформа, яка дозволяє людям отримувати пасивний дохід на ринку Diamond на додаток до зростання вартості.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Реєстраційний № DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Про компанію',
    titleLines: [ 'МІЖНАРОДНА', 'СТРУКТУРА', 'ЧІТКЕ БАЧЕННЯ' ],
    body: 'STIG ROCK була заснована, щоб зробити ринок Diamond більш прозорим, сучасним і орієнтованим на клієнта — з фокусом на довіру, безпеку та довгострокову структуру.'
  },
  sicherheit: {
    overline: 'Якість та безпека',
    title: 'Gemological Institute of America',
    body: 'Сертифікована експертиза для ваших Diamond. Магістр Томас Адлер з GIA оцінює кожен камінь з найвищою точністю та багаторічним досвідом — надійні експертні висновки для нашої компанії та наших клієнтів.',
    transparency: 'Кожен Diamond відповідає найвищим стандартам якості та проходить перевірку й сертифікацію у визнаних організаціях. Кожен камінь унікальний і має індивідуальний сертифікат.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Унікальна інновація продукту',
    sub: 'Шість рівнів Solution Pläne — від $1K до $100K+, кожен із зростаючою знижкою на місяць та протягом усього терміну.',
    recommended: 'Популярно',
    oneYear: '1 рік',
    rowLabels: {
      delivery: 'Термін доставки',
      price: 'Ціна продукту',
      carat: 'ct',
      monthly: 'Знижка (місяць)',
      totalDiscount: 'Знижка (разом)',
      duration: 'Термін дії'
    },
    headers: {
      plan: 'План',
      from: 'Від',
      carat: 'ct',
      monthly: 'Знижка / міс.',
      total: 'Знижка разом',
      duration: 'Термін дії'
    },
    duration: '1 рік',
    footnote: 'Усі ціни вказані без гарантії та залежать від якості, попиту та поточної ринкової ситуації. Плани Solution також можливі на 2 роки.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-пакет',
    title: 'Більше переваг з VIP-Paket',
    sub: 'Поєднайте свій Solution Plan з VIP-Paket і отримайте додаткові цінові переваги до 3 %. Так ви збільшите свою загальну знижку і забезпечите собі ще привабливіші умови.',
    rowLabels: {
      delivery: 'Термін доставки',
      price: 'Ціна продукту',
      carat: 'ct',
      monthly: 'Знижка (місяць)',
      totalDiscount: 'Знижка (разом)',
      vip1: 'VIP-пакет 1 (+1%)',
      vip2: 'VIP-пакет 2 (+2%)',
      vip3: 'VIP-пакет 3 (+3%)'
    },
    footnote: 'Усі ціни вказані без гарантії та залежать від якості, попиту та поточної ринкової ситуації.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Більше переваг з VIP-Paket',
    sub: 'Поєднайте свій Solution Plan з VIP-Paket і отримайте додаткові цінові переваги до 3 %. Так ви збільшите свою загальну знижку і забезпечите собі ще привабливіші умови.',
    options: [
      {
        key: 'deliver',
        title: 'Більше переваг з VIP-Paket',
        body: 'Diamond (ct) за ціною вашого DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Продати нам',
        body: 'Ви можете перепродати нам свої Diamond за ціною покупки, яку ви сплатили.'
      },
      {
        key: 'sellThirdParty',
        title: 'Продати третім особам',
        body: 'Ви можете перепродати свої Diamond третім особам.'
      }
    ],
    footnote: '*DS-Plan означає Solution план.'
  },
  tradWeg: {
    overline: 'Традиційна торгівля',
    title: 'Традиційний шлях',
    sub: 'Перш ніж Diamond потрапить до кінцевого споживача, через посередницьку, оптову та роздрібну торгівлю виникають значні торгові націнки порівняно з ціною необробленого Diamond з шахти.',
    steps: [
      { title: 'Шахта', subtitle: 'Необроблені Diamond' },
      { title: 'Посередник', subtitle: 'Закупівля сировини' },
      { title: 'Огранювання', subtitle: 'Огранювання в ювелірні Diamond' },
      { title: 'Сертифікація', subtitle: 'визнаними інститутами, такими як GIA' },
      { title: 'Алмазна біржа', subtitle: 'Продаж оптовикам' },
      { title: 'Оптова торгівля', subtitle: 'Продаж у роздріб' },
      { title: 'Роздрібна торгівля', subtitle: 'напр., ювелірні магазини' },
      { title: 'Кінцевий клієнт', subtitle: 'Купівля Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-пакети',
    sub: 'Діють протягом 12 місяців на всі підписані вами плани Solution. Залежно від VIP-пакета: від +1% до +3% додаткової знижки',
    cardKicker: 'додатково – на всі',
    cardKicker2: 'Solution плани',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Знижки перетворюються на заощадження',
      body: 'Щомісячне заощадження замість щомісячного навантаження. Зі знижок виникають заощадження — і вони оплачують саме ті речі, за які ви зазвичай платите щомісяця з власної кишені.',
      line1Label: 'DS-Plan від',
      line1Value: '$5.000',
      line2Label: 'міс. знижка',
      line2Value: '3%',
      line3Label: 'VIP-пакет 3',
      line3Value: '+3%',
      resultLabel: 'міс. заощадження',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Як це можливо?',
    title: 'Ми переосмислили ланцюжок створення вартості.',
    traditionalTitle: 'Традиційний шлях',
    traditionalSteps: [
      'Шахта — необроблені Diamond',
      'Посередник — закупівля',
      'Огранювальна майстерня — шліфування',
      'Сертифікація (GIA)',
      'Алмазна біржа — оптова торгівля',
      'Оптова торгівля → роздрібна торгівля',
      'Ювеліри → кінцевий клієнт'
    ],
    traditionalNote: 'Перш ніж Diamond потрапить до кінцевого споживача, через посередників виникають значні торгові націнки.',
    stigTitle: 'Шлях STIG ROCK',
    stigSteps: [
      'Пряма закупівля — сировина з шахти',
      'Огранювання та сертифікація через наших Partner',
      'Продаж кінцевим клієнтам та B2B клієнтам',
      'До 4 торгових циклів на рік'
    ],
    stigNote: 'Ми розриваємо коло і передаємо торгові націнки нашим клієнтам як знижки — до 4 торгових циклів протягом терміну дії DS-Plan.'
  },
  optionen: {
    overline: 'Ваші можливості',
    title: 'Після закінчення плану Solution',
    items: [
      { title: 'Доставка', body: 'Diamond (ct) за ціною вашого DS-Plan.' },
      { title: 'Продати нам', body: 'Зворотний викуп за ціною покупки, яку ви сплатили.' },
      { title: 'Продати третім особам', body: 'Продаж Diamond на вільному ринку.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution плани — унікальна інновація продукту',
    title: 'Простий шлях',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Реєстрація',
        body: "Зв'яжіться зі своїм рекомендателем і створіть безкоштовний аккаунт!"
      },
      { n: '02', icon: 'cart', title: 'Купівля продукту', body: 'Вже від $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Отримання знижок',
        body: 'Отримуйте щомісячні нарахування знижок.'
      }
    ]
  },
  business: {
    overline: 'Види бонусів',
    title: 'Найпростіший і найсправедливіший шлях.',
    sub: "П'ять видів бонусів — для вашої успішної розбудови бізнесу.",
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: "До Level 3, від кар'єрного ступеня Pearl / Ruby."
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Від Sapphire — на необмежену глибину.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'На Infinity Bonus – до Level 5 · БЕЗ кваліфікації.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 пули від світового обороту.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Одноразовий бонус у Diamond (ct).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Цей бонус виплачується вам за кожен новий підписаний план Solution до 3-го рівня. Ви відкриваєте окремі рівні з мінімальними кваліфікаціями.',
    total: 'До 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'від самого початку',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: "від кар'єрного ступеня Pearl",
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: "від кар'єрного ступеня Ruby",
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: "Від кар'єрного ступеня Sapphire ви кваліфікуєтесь для нашого плану Infinity Bonus. Ви отримуєте 3% бонуса. З кожним новим кар'єрним ступенем додаються нові відсотки. Якщо Partner у вашій команді також кваліфікований, ви отримуєте різницю між рангами.",
    exampleTitle: 'Приклад',
    exampleRows: [
      { label: 'Ви Blue Diamond', value: '12%' },
      { label: 'Ваш Partner — Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Ваш Infinity Bonus', value: '9%' },
    totalNote: 'Загалом до 24% Infinity Bonus на всі плани Solution у вашій команді — на необмежену глибину.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Завдяки цьому бонусу ви отримуєте вигоду від успіху вашої команди. Ви отримуєте Matching Bonus у розмірі 5% від Infinity Bonus ваших Partner — до 5-го рівня вашої команди.',
    note: 'На всі виплати Infinity Bonus у вашій команді – до 5-го рівня. Від самого початку – БЕЗ кваліфікації.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Загалом до',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: "3% світового обороту розподіляються порівну між 3 різними пулами. Досягаючи певних кар'єрних ступенів, ви кваліфікуєтесь для кожного окремого пулу.",
    forever: 'Один раз досягнуто – участь НАЗАВЖДИ!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'від Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'від Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'від Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Загалом',
    totalValue: '3%',
    totalSuffix: 'світового обороту'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: "Починаючи з кар'єрного ступеня Emerald, ви отримуєте Rang Bonus. Він виплачується в Diamond (ct). Це одноразовий бонус.",
    highlight: 'Diamond (ct) на загальну суму',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: "Кар'єрні ступені",
    sub: "Для досягнення відповідних кар'єрних ступенів враховується історичний загальний оборот (HG). Починаючи зі ступеня Sapphire, він має бути розподілений між кількома командами. Щоб досягти Ruby або вище, вам потрібно мінімум два прямих Partner з планом STIG ROCK.",
    forever: 'Один раз досягнуто – підтверджено НАЗАВЖДИ!',
    footnote: 'HV = Історичний загальний оборот.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 дир. Partner', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Стартуйте з нами',
    title: 'Правильний час — саме зараз.',
    body: "Ця бізнес-модель встановлює нові стандарти та об'єднує всі фактори успіху для довгостроково сталого та успішного бізнесу. Зареєструйтесь сьогодні, оберіть свій план Solution та скористайтеся цією унікальною бізнес-можливістю.",
    hint: 'Поговоріть з особою, яка запросила вас на цю презентацію — вона має посилання для реєстрації.',
    formName: "Ім'я",
    formEmail: 'E-Mail',
    formPhone: 'Телефон',
    formSubmit: "Зв'язатися",
    success: "Дякуємо — ми зв'яжемося з вами конфіденційно та особисто.",
    callCta: 'Подзвонити',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Юридична примітка & Disclaimer',
    disclaimer: "Ця презентація служить виключно для інформаційних цілей і не є фінансовою, інвестиційною або податковою консультацією. STIG ROCK не є фінансовим продуктом, а стосується натуральних Diamond як реальних активів. Жодних гарантій щодо динаміки вартості, прибутку або доходів не надається. Показники минулого не є індикатором майбутніх результатів. Усі представлені розрахунки, пов'язані з комісійними, є лише прикладами і також не є гарантією. Можливі зміни вмісту — вільний переклад (не є офіційним перекладом).",
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Усі права захищено.',
    version: 'Версія: DS-12-2025 V3'
  },
  misc: { next: 'Наступний розділ' }
};

export default uk;
